import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, renderSlot as _renderSlot, toDisplayString as _toDisplayString, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d465e858"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "logo-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "them-wrapper p-1 _pointer-on-hover rounded-full hover:text-gray-700 hover:bg-gray-200 dark:hover:bg-gray-700 dark:hover:text-white"
}
const _hoisted_7 = { class: "_pointer-on-hover _prevent-text-select mr-3" }
const _hoisted_8 = { class: "rec-badge _pointer-on-hover _prevent-text-select" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Rec", -1))
const _hoisted_10 = { class: "right" }

import { computed, ref, PropType } from 'vue'
import useTheme from '@/composables/useTheme'
// import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { MoonIcon, SunIcon } from '@heroicons/vue/24/outline'
import LeavePopup from '@/components/room/LeavePopup.vue'
import useAuth from '@/composables/api/useAuth'
import LessonPopup from '@/components/room/LessonPopup.vue'
import { IParticipantCapabilities } from '@/types/interfaces/participant.interface'
import { logoPathDark, logoPathLight, logoIcon } from '@/data/room'
import FeedbackClassButton from '@/components/room/FeedbackClassButton.vue'
import { VERSION } from '@/composables/api'

export default /*#__PURE__*/_defineComponent({
  __name: 'RoomNavbar',
  props: {
  userPermissions: {
    type: Object as PropType<IParticipantCapabilities>,
    required: true,
  },
  appVersion: {
    type: String,
    default: VERSION,
  },
  avatar: {
    type: String,
    default: logoIcon,
  },
  logoPath: {
    type: String,
    default: logoPathDark,
  },
  isMainEngine: {
    type: Boolean,
    default: true,
  },
  supportTel: {
    type: String,
    default: '',
  },
  supportEmail: {
    type: String,
    default: '',
  },
  currentEngine: {
    type: String,
    default: 'twilio',
  },
  exitPath: {
    type: String,
    default: '',
  },
  isRecording: {
    type: Boolean,
    default: false,
  },
  haveTrackLesson: {
    type: Boolean,
    default: false,
  },
  helpEnable: {
    type: Boolean,
    default: false,
  },
  isWhereby: {
    type: Boolean,
    default: false,
  },
  canChangeTheme: {
    type: Boolean,
    default: false,
  },
},
  emits: ['toggle-help', 'open-device-setting'],
  setup(__props, { emit: __emit }) {

const { getAccessInfo } = useAuth()

const props = __props
const emit = __emit
/**
 * State
 */
const { isDark, changeTheme } = useTheme()
const classId = ref(parseInt(sessionStorage.getItem('external_room_id') || ''))
const isOpenedLeavePopup = ref(false)
const isOpenedLessonPopup = ref(false)
const recordTooltip = ref(false)
const isFromLessonBtn = ref(false)
const isSavedLesson = ref(false)
const lessonTooltip = ref(false)
const currentRoomTooltip = ref(false)
/**
 * Computed
 */
const showTrackLesson = computed(
  () =>
    !!classId.value &&
    !isNaN(classId.value) &&
    props.userPermissions?.trackLesson &&
    props.haveTrackLesson,
)
const showFeedbackClass = computed(
  () => !!classId.value && !isNaN(classId.value) && props.userPermissions?.feedbackClass,
)
const logo = computed(() => (isDark.value ? props.logoPath : logoPathLight))

/**
 * Methods
 */

const goToMainPage = () => {
  const { queryToken } = getAccessInfo()
  window.location.href = `/?token=${queryToken}`
  location.reload()
}

const clickLeaveButton = (fromlessonBtn?: boolean) => {
  isFromLessonBtn.value = fromlessonBtn || false
  if (showTrackLesson.value) {
    isOpenedLessonPopup.value = true
  } else {
    isOpenedLeavePopup.value = true
  }
}
const clickLeaveFromLessonPopup = () => {
  isOpenedLessonPopup.value = false
  isOpenedLeavePopup.value = true
}

const submitLessonSuccess = () => {
  isSavedLesson.value = true
  if (isFromLessonBtn.value) return
  isOpenedLeavePopup.value = true
}

const openHelp = () => {
  emit('toggle-help')
}

const openDeviceSettingPopup = () => {
  emit('open-device-setting')
}

return (_ctx: any,_cache: any) => {
  const _component_LanguageDropdown = _resolveComponent("LanguageDropdown")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "_prevent-text-select logo",
          src: logo.value,
          draggable: "false",
          onClick: goToMainPage
        }, null, 8, _hoisted_4),
        _createElementVNode("img", {
          class: "_prevent-text-select logo-icon",
          src: _unref(logoIcon),
          draggable: "false",
          onClick: goToMainPage
        }, null, 8, _hoisted_5)
      ]),
      (__props.canChangeTheme)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_unref(isDark))
              ? (_openBlock(), _createBlock(_unref(MoonIcon), {
                  key: 0,
                  "aria-hidden": "true",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(changeTheme)('light')))
                }))
              : (_openBlock(), _createBlock(_unref(SunIcon), {
                  key: 1,
                  "aria-hidden": "true",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(changeTheme)('dark')))
                }))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_LanguageDropdown, {
        class: "language-dropdown-navbar",
        "by-theme": ""
      }),
      (!__props.isWhereby)
        ? (_openBlock(), _createBlock(_component_Popper, {
            key: 1,
            placement: "right",
            show: currentRoomTooltip.value,
            hover: true,
            arrow: true,
            content: 
          __props.isMainEngine
            ? _ctx.$t('current-room-tooltip.main-room')
            : _ctx.$t('current-room-tooltip.secondary-room')
        ,
            onMouseover: _cache[2] || (_cache[2] = ($event: any) => (currentRoomTooltip.value = true)),
            onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (currentRoomTooltip.value = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createVNode(_component_SvgIcon, {
                  class: "_pointer-on-hover",
                  icon: "siren",
                  "inherit-fill": true,
                  height: "21"
                }, null, 512), [
                  [_vShow, !__props.isMainEngine]
                ]),
                _withDirectives(_createVNode(_component_SvgIcon, {
                  class: "_pointer-on-hover",
                  icon: "home",
                  "inherit-fill": true,
                  height: "21"
                }, null, 512), [
                  [_vShow, __props.isMainEngine]
                ])
              ])
            ]),
            _: 1
          }, 8, ["show", "content"]))
        : _createCommentVNode("", true),
      (__props.isRecording)
        ? (_openBlock(), _createBlock(_component_Popper, {
            key: 2,
            show: recordTooltip.value,
            hover: true,
            arrow: true,
            content: _ctx.$t('recording-tooltip'),
            onMouseover: _cache[4] || (_cache[4] = ($event: any) => (recordTooltip.value = true)),
            onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (recordTooltip.value = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_SvgIcon, {
                  class: "_pointer-on-hover",
                  icon: "record",
                  "inherit-fill": true,
                  height: "21"
                }),
                _hoisted_9
              ])
            ]),
            _: 1
          }, 8, ["show", "content"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _renderSlot(_ctx.$slots, "default"),
      (showTrackLesson.value)
        ? (_openBlock(), _createBlock(_component_Popper, {
            key: 0,
            show: isSavedLesson.value ? lessonTooltip.value : false,
            hover: true,
            arrow: true,
            content: _ctx.$t('lesson-tooltip'),
            onMouseover: _cache[7] || (_cache[7] = ($event: any) => (lessonTooltip.value = true)),
            onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (lessonTooltip.value = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "btn-action-nav nav-menu-item",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (clickLeaveButton(true)))
              }, [
                _createVNode(_component_SvgIcon, {
                  class: "_pointer-on-hover mr-1",
                  icon: "pen",
                  "inherit-fill": true,
                  height: "26"
                }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('lesson')), 1)
              ])
            ]),
            _: 1
          }, 8, ["show", "content"]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "btn-action-nav nav-menu-item sos-btn",
        onClick: openHelp
      }, [
        _createVNode(_component_SvgIcon, {
          class: "_pointer-on-hover mr-1",
          icon: "warning",
          "inherit-fill": true,
          height: "26"
        }),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('help')), 1)
      ]),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(LessonPopup, {
          modelValue: isOpenedLessonPopup.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isOpenedLessonPopup).value = $event)),
          "class-id": classId.value,
          "is-from-lesson-btn": isFromLessonBtn.value,
          onSuccess: submitLessonSuccess,
          onLeave: clickLeaveFromLessonPopup
        }, null, 8, ["modelValue", "class-id", "is-from-lesson-btn"])
      ])),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(LeavePopup, {
          modelValue: isOpenedLeavePopup.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((isOpenedLeavePopup).value = $event)),
          "exit-path": __props.exitPath
        }, null, 8, ["modelValue", "exit-path"])
      ])),
      (showFeedbackClass.value)
        ? (_openBlock(), _createBlock(FeedbackClassButton, {
            key: 1,
            "exit-path": __props.exitPath,
            class: "ml-5"
          }, null, 8, ["exit-path"]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "btn-action-nav leave-button nav-menu-item",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (clickLeaveButton(false)))
      }, [
        _createVNode(_component_SvgIcon, {
          class: "_pointer-on-hover mr-1",
          icon: "leave",
          "inherit-fill": true,
          height: "26"
        }),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('leave-button')), 1)
      ])
    ])
  ]))
}
}

})